import { KeyboardArrowDown } from "@mui/icons-material";
import { MenuItem, Select, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import useService from "../../../../../../hooks/useService";

const Routes = () => {
  const routeRepository = useService("repositories/route-repository");
  const { route_id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [routes, setRoutes] = useState([]);

  const fetchRoutes = async () => {
    try {
      const data = await routeRepository.query();
      if (!data.length || data.length === 0) {
        navigate("/search", { replace: true });
        return;
      }
      setRoutes(data);
    } catch (error) {
      console.error("Error fetching routes:", error);
      return error;
    }
  };

  useEffect(() => {
    fetchRoutes();
  }, []);

  function handleChange(value) {
    navigate({
      pathname: `/dashboard/${value}`,
      search: location.search,
    });
  }

  if (!routes || routes.length === 0) {
    return null;
  }

  if (routes.length === 1) {
    return (
      <Typography className="p-0 text-2xl font-normal text-blue-700">
        {routes[0].display || routes[0].route}
      </Typography>
    );
  }

  return (
    <Select
      className="w-full bg-transparent p-0 text-2xl font-normal text-blue-700"
      fullWidth
      IconComponent={({ className }) => {
        return <KeyboardArrowDown className={`ml-2 text-blue-700 ${className} transition-all`} />;
      }}
      onChange={(event) => handleChange(event.target.value)}
      size="small"
      sx={{
        "&::before": {
          display: "none !important",
        },
        "&::after": {
          display: "none !important",
        },
        "&.Mui-focused": {
          backgroundColor: "transparent !important",
        },
        "&.Mui-focused .MuiSelect-select": {
          backgroundColor: "transparent !important",
        },
      }}
      value={route_id ? Number(route_id) : ""}
      variant="standard"
    >
      {routes.map((route) => (
        <MenuItem key={route.id} value={route.id}>
          {route.display || route.route}
        </MenuItem>
      ))}
    </Select>
  );
};

export default Routes;
